import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { FeedEntriesProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const FEED_ENTRIES_QUERY = graphql`
query NodeAllFeedEntriesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "FeedEntries" } }) {
    nodes {
      data
    }
  }
}
`;

export const FeedEntriesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(FEED_ENTRIES_QUERY), 'items')}>{children}</Provider>;
};
